/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BagBriefcaseIcon16Light } from './BagBriefcaseIcon16Light';
import { BagBriefcaseIcon16Regular } from './BagBriefcaseIcon16Regular';
import { BagBriefcaseIcon16Solid } from './BagBriefcaseIcon16Solid';
import { BagBriefcaseIcon20Light } from './BagBriefcaseIcon20Light';
import { BagBriefcaseIcon20Regular } from './BagBriefcaseIcon20Regular';
import { BagBriefcaseIcon20Solid } from './BagBriefcaseIcon20Solid';
import { BagBriefcaseIcon24Regular } from './BagBriefcaseIcon24Regular';
import { BagBriefcaseIcon24Solid } from './BagBriefcaseIcon24Solid';
import { BagBriefcaseIcon32Regular } from './BagBriefcaseIcon32Regular';
import { BagBriefcaseIcon64Regular } from './BagBriefcaseIcon64Regular';
var sizes = {
    16: {
        light: BagBriefcaseIcon16Light,
        regular: BagBriefcaseIcon16Regular,
        solid: BagBriefcaseIcon16Solid,
    },
    20: {
        light: BagBriefcaseIcon20Light,
        regular: BagBriefcaseIcon20Regular,
        solid: BagBriefcaseIcon20Solid,
    },
    24: {
        regular: BagBriefcaseIcon24Regular,
        solid: BagBriefcaseIcon24Solid,
    },
    32: {
        regular: BagBriefcaseIcon32Regular,
    },
    64: {
        regular: BagBriefcaseIcon64Regular,
    },
};
export var BagBriefcaseIcon = forwardRef('BagBriefcaseIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
